import { useNavigate } from 'react-router-dom';

const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/#about' },
  { label: 'I am a Seller', href: '/sellers' },
  { label: 'I am a Real Estate Agent', href: '/agents' },
  { label: 'FAQ', href: '/#faq' },
  { label: 'Contact', href: '/#contact' },
];

const sellerLinks = [
  { label: 'SureBuy Program', href: '/sellers' },
  { label: 'Get a Written Offer', href: '/sellers#offer-form' },
  { label: 'Downsizing', href: '/sellers' },
  { label: 'Upgrading', href: '/sellers' },
  { label: 'Unique Circumstances', href: '/sellers' },
];

const agentLinks = [
  { label: 'Partner With Us', href: '/agents' },
  { label: 'Submit a Property', href: '/agents' },
  { label: 'Our Buying Criteria', href: '/agents' },
  { label: 'Off-Market Deals', href: '/agents' },
  { label: 'Contact Us', href: '/#contact' },
];

export default function Footer() {
  const navigate = useNavigate();

  const handleLink = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    if (href.includes('#')) {
      const [path, hash] = href.split('#');
      if (path && window.location.pathname !== path) {
        navigate(path);
        setTimeout(() => {
          document.querySelector(`#${hash}`)?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      } else {
        document.querySelector(`#${hash}`)?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(href);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1C3A3A] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/97714bd9b358da41691b55298de3f442/a3ed0c045a06ae061d06a7b185ca2783.png"
              alt="ReadyBuyer Group"
              className="h-24 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-teal-300 text-sm leading-relaxed mb-4">
              Melbourne&apos;s direct property buyers network. Fast, certain, fee-free.
            </p>
            <div className="text-xs text-teal-400 space-y-1">
              <div>Services Marketplace Pty Ltd</div>
              <div>ABN: 62 631 153 216</div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-teal-400 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleLink(e, link.href)}
                    className="text-sm text-gray-300 hover:text-teal-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* For Sellers */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-teal-400 mb-5">For Sellers</h4>
            <ul className="space-y-3">
              {sellerLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => handleLink(e, item.href)}
                    className="text-sm text-gray-300 hover:text-teal-300 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* For Agents */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-teal-400 mb-5">For Agents</h4>
            <ul className="space-y-3">
              {agentLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => handleLink(e, item.href)}
                    className="text-sm text-gray-300 hover:text-teal-300 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Bar */}
        <div className="border-t border-teal-800 pt-8 mb-8">
          <div className="flex flex-col md:flex-row gap-6 md:gap-12">
            <a href="tel:0411499997" className="flex items-center gap-3 text-sm text-gray-300 hover:text-teal-300 transition-colors cursor-pointer">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-teal-400"></i>
              </div>
              0411 499 997
            </a>
            <a href="mailto:info@readybuyergroup.com.au" className="flex items-center gap-3 text-sm text-gray-300 hover:text-teal-300 transition-colors cursor-pointer">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-teal-400"></i>
              </div>
              info@readybuyergroup.com.au
            </a>
            <div className="flex items-center gap-3 text-sm text-gray-300">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-2-line text-teal-400"></i>
              </div>
              Ground Floor, 470 St Kilda Road, Melbourne VIC 3004
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-teal-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">
            &copy; 2025 Services Marketplace Pty Ltd. All rights reserved.
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-gray-400 hover:text-teal-300 transition-colors cursor-pointer" rel="nofollow">Privacy Policy</a>
            <a href="#" className="text-xs text-gray-400 hover:text-teal-300 transition-colors cursor-pointer" rel="nofollow">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
